import React from "react";

import Tabs from "@arachnys/styleguide/Tabs";
import NarrativeTable from "./NarrativeTable";
import ProcessHistoryInfoTable from "./InfoTable";

const MergeEntityProcessHistory = props => {
    const tabs = [
        {
            label: "Info",
            key: "info",
            content: (
                <ProcessHistoryInfoTable
                    processRelayId={props.processRelayId}
                    schema={props.schema}
                    oldEntityKey="original_entity"
                />
            ),
        },
        {
            label: "Narrative",
            key: "narrative",
            content: (
                <NarrativeTable
                    processRelayId={props.processRelayId}
                    schema={props.schema}
                />
            ),
        },
    ];

    return <Tabs defaultActiveKey="info" tabs={tabs} />;
};

export default MergeEntityProcessHistory;
